import { useOutletContext } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import { BASE_MOBILE_API_URL, BASIC_AUTH } from "../constants";
import axios from "axios";
import { notifyError } from "../components/notify";
import TableLoader from "../components/Spinner/TableLoader";
const Offers = () => {
  const { setPageTitle } = useOutletContext();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);

  const customerStr = localStorage.getItem("customerInfo");
  const customer = customerStr ? JSON.parse(customerStr) : null;
  useEffect(() => {
    setPageTitle("Offers");
  }, [setPageTitle]);

  const getOfferList = useCallback(async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${BASE_MOBILE_API_URL}/get_offers_master`,
        {
          params: {
            companycode: customer?.companycode,
            supervisorcode: customer?.customercode,
            branchcode: customer?.branchcode,
          },
          headers: {
            Authorization: BASIC_AUTH,
          },
        }
      );

      const result = response.data;
      setOffers(result);
    } catch (err) {
      if (err.response) {
        // Server responded with error status
        const errorMessage =
          err.response?.data && typeof err.response.data === "string"
            ? err.response.data
            : err.response?.data?.message ||
              err.response?.data?.error ||
              "Fatch offer list failed";

        notifyError(errorMessage);
      } else if (err.request) {
        // No response received
        notifyError("Server not responding. Please try again.");
      } else {
        // Other errors
        notifyError("Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  }, [customer]);

  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;

    hasFetched.current = true;
    getOfferList();
  }, [getOfferList]);

  return (
    <>
      {loading ? (
            <TableLoader
              message={`Loading offres...`}
              size="sm"
              messageClass="tablemessage-white"
              spinnerClass="tablespinner-white"
            />
          ) : (
      <div className="col-12 d-flex justify-content-center">
        <div className="col-12 col-md-6 col-lg-6 bg-black p-3">
          {offers.map((offer) => (
            <div key={offer.offercode} className="offer-wrapper">
              <div className="offer-card">
                <img
                  src={offer.offerimage}
                  alt={offer.name}
                  className="offer-img"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
          )}
    </>
  );
};
export default Offers;
